import { atom } from 'jotai'

export const selectedCandidateIdsAtom = atom<Set<string>>(new Set<string>())

export const selectedCountAtom = atom<number>(
	(get) => get(selectedCandidateIdsAtom).size,
)

export const toggleCandidateSelectionAtom = atom(
	null,
	(get, set, candidateId: string) => {
		const next = new Set(get(selectedCandidateIdsAtom))
		if (next.has(candidateId)) {
			next.delete(candidateId)
		} else {
			next.add(candidateId)
		}
		set(selectedCandidateIdsAtom, next)
	},
)

export const clearSelectionAtom = atom(
	null,
	(_get, set) => {
		set(selectedCandidateIdsAtom, new Set())
	},
)

// Toggle-all over a given id list: if every id is already selected, deselect
// them; otherwise add all of them. Ids outside the list are left untouched.
export const selectAllAtom = atom(
	null,
	(get, set, candidateIds: string[]) => {
		const prev = get(selectedCandidateIdsAtom)
		const allSelected = candidateIds.length > 0 && candidateIds.every(id => prev.has(id))
		const next = new Set(prev)

		if (allSelected) {
			for (const id of candidateIds) {
				next.delete(id)
			}
		} else {
			for (const id of candidateIds) {
				next.add(id)
			}
		}

		set(selectedCandidateIdsAtom, next)
	},
)

export function getGroupSelectionState(
	ids: string[],
	selectedIds: Set<string>,
): { checked: boolean; indeterminate: boolean } {
	let allSelected = ids.length > 0
	let someSelected = false

	for (const id of ids) {
		if (selectedIds.has(id)) {
			someSelected = true
		} else {
			allSelected = false
		}
		if (someSelected && !allSelected) {
			break
		}
	}

	return { checked: allSelected, indeterminate: someSelected && !allSelected }
}
